import React, { useEffect, useState } from 'react'
import { Button, Card, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import CardBodyContentContainer from '../../../common/styles/CardBodyContentContainer'
import CardTitle from '../../../common/styles/CardTitle'
import BooksitoutIcon from '../../../config/BooksitoutIcon'
import Modal from '../../../common/Modal'
import { BooksitoutServer } from '../../../config/BooksitoutServer'

// Owner of the membership (can be a family member's) — shown on the Apple Wallet pass
interface Props {
	ownerNameFromServer: string | null
	onChange?: (ownerName: string | null) => void
}

const LibraryMembershipDetailOwnerNameCard: React.FC<Props> = ({ ownerNameFromServer, onChange }) => {
	const { membershipId } = useParams()

	const [ownerName, setOwnerName] = useState(ownerNameFromServer)
	const [showModal, setShowModal] = useState(false)
	const [newOwnerName, setNewOwnerName] = useState('')

	useEffect(() => {
		setOwnerName(ownerNameFromServer)
	}, [ownerNameFromServer])

	const openModal = () => {
		setNewOwnerName(ownerName ?? '')
		setShowModal(true)
	}

	const handleSubmit = e => {
		e?.preventDefault()
		const trimmed = newOwnerName.trim()

		// "" clears it on the server
		BooksitoutServer.put(`/v1/library/membership/${membershipId}`, { ownerName: trimmed })
			.then(() => {
				const saved = trimmed === '' ? null : trimmed
				setOwnerName(saved)
				onChange?.(saved)
				setShowModal(false)
			})
			.catch(() => toast.error('오류가 났어요. 잠시 후 다시 시도해 주세요'))
	}

	return (
		<>
			<Card>
				<CardBodyContentContainer>
					<CardTitle icon={<BooksitoutIcon.user />} title={`소유자`} subTitle={undefined} textSize={2} url={''} />

					<div className="clickable" onClick={openModal} style={{ padding: '10px 20px', textAlign: 'center' }}>
						{ownerName ? (
							<span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{ownerName}</span>
						) : (
							<span style={{ color: '#666', fontStyle: 'italic' }}>소유자 이름이 설정되지 않았어요</span>
						)}
					</div>
				</CardBodyContentContainer>
			</Card>

			<Modal
				isShowing={showModal}
				onClose={() => setShowModal(false)}
				titleText="회원증 소유자 이름"
				size="md"
				body={
					<Form onSubmit={handleSubmit}>
						<Form.Group className="mb-3">
							<Form.Control
								type="text"
								placeholder="회원증 소유자 이름"
								value={newOwnerName}
								onChange={e => setNewOwnerName(e.target.value)}
								maxLength={20}
								autoFocus
								autoComplete="off"
							/>
						</Form.Group>
						<div className="d-flex gap-2">
							<Button variant="secondary" onClick={() => setShowModal(false)} className="flex-fill">
								취소
							</Button>
							<Button variant="book" onClick={handleSubmit} className="flex-fill">
								저장
							</Button>
						</div>
					</Form>
				}
			/>
		</>
	)
}

export default LibraryMembershipDetailOwnerNameCard
